export default __webpack_public_path__ + "static/media/gallery_08.07e59a4c.jpg";